import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-s-minus",
  "use": "icon-s-minus-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"icon-s-minus\"><path fill-rule=\"evenodd\" d=\"M1 10H21V12H1z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol